import type { RouteRecordRaw } from 'vue-router'

import { CUSTOMER_CARE } from './route-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'dashboard/diagnosis/new/:orderlineId',
      name: CUSTOMER_CARE.DIAGNOSIS.SELF,
      component: () => import('~/scopes/customer-care/diagnosis/Diagnosis.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        layout: 'customer-care-minimal',
        tracking: { contentGroup: 'Diagnosis' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      path: 'dashboard/resolution/new/:orderlineId/:customerIssues',
      name: CUSTOMER_CARE.RESOLUTION.SELF,
      component: () =>
        import('~/scopes/customer-care/resolution/ResolutionFlow.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        layout: 'customer-care-minimal',
        tracking: { contentGroup: 'Resolution' },
        shoppingAssistant: { enabled: false },
      },
      children: [
        {
          name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.SELF,
          path: 'express-replacement',
          component: () =>
            import('@backmarket/nuxt-layer-base/components/RouteRecordWithChildrenOnly/RouteRecordWithChildrenOnly.vue'),
          meta: {
            tracking: { contentGroup: 'Express Replacement' },
          },
          children: [
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.DETAILS,
              path: 'details',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/details/ExpressReplacementDetails.vue'),
            },
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.SHIPPING,
              path: 'shipping',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/shipping/ExpressReplacementShipping.vue'),
            },
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.DATA_REMOVAL,
              path: 'data-removal',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/data-removal/ExpressReplacementDataRemoval.vue'),
            },
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.PICTURES,
              path: 'pictures',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/pictures/ExpressReplacementPictures.vue'),
            },
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.CONTACT,
              path: 'contact',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/contact/ExpressReplacementContact.vue'),
            },
            {
              name: CUSTOMER_CARE.RESOLUTION.EXPRESS_REPLACEMENT.PAYMENT,
              path: ':resolutionId/payment',
              component: () =>
                import('~/scopes/customer-care/resolution/pages/express-replacement/payment/ExpressReplacementPayment.vue'),
            },
          ],
        },
      ],
    },
    {
      path: 'dashboard/resolution/confirmation/:resolutionId?',
      name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_CONTACT_CONFIRMATION,
      component: () =>
        import('~/scopes/customer-care/resolution/confirmationPages/contact/ContactConfirmationPage.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        tracking: { contentGroup: 'Resolution' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      path: 'dashboard/resolution/return/confirmation/:resolutionId',
      name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_RETURN_CONFIRMATION,
      component: () =>
        import('~/scopes/customer-care/resolution/confirmationPages/return/ReturnConfirmationPage.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        layout: 'customer-care-minimal',
        tracking: { contentGroup: 'Resolution' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      path: 'dashboard/resolution/straight-refund/confirmation',
      name: CUSTOMER_CARE.RESOLUTION.RESOLUTION_STRAIGHT_REFUND_CONFIRMATION,
      component: () =>
        import('~/scopes/customer-care/resolution/confirmationPages/straightRefund/StraightRefundConfirmationPage.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        tracking: { contentGroup: 'Resolution' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      path: 'dashboard/resolution/express-replacement/confirmation/:resolutionId',
      name: CUSTOMER_CARE.RESOLUTION
        .RESOLUTION_EXPRESS_REPLACEMENT_CONFIRMATION,
      component: () =>
        import('~/scopes/customer-care/resolution/confirmationPages/express-replacement/ExpressReplacementConfirmation.vue'),
      meta: {
        authenticated: {
          required: true,
        },
        owners: ['bot-squad-sales-customer-care-front'],
        layout: 'customer-care-minimal',
        tracking: { contentGroup: 'Resolution' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]
}
